var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 17.7c2.5 0 4.3-1.4 4.6-4.3h-2.5c-.2 1-.8 1.5-2.1 1.5-1.4 0-2-.5-2.3-1.5h-2.4c.3 3 2.1 4.3 4.7 4.3ZM53.7 29.5V19h-3.1v15.3h3.2l6.3-10.7v10.7h3.1V19H60l-6.3 10.5ZM40.8 19.1a6 6 0 0 0-5.6 3.3c.1-3.5.8-5.5 4.8-6l6.2-1L46 12l-6.5 1c-5.6.7-7.2 5-7.2 11.9 0 6 2.7 9.7 7.7 9.7 4.9 0 7.5-3.8 7.5-8.2 0-4.4-3-7.3-6.7-7.3ZM40 31.2c-2.8 0-4.5-2-4.5-5.1v-1.6c.6-1.2 2.2-2.1 4.5-2.1 2.4 0 4.3 1.1 4.3 4 0 3-1.5 4.8-4.3 4.8ZM123.9 19v5.7h-6V19h-3.2v15.3h3.1V28h6v6.4h3.2V19h-3.1Zm-22.6 10.5V19h-3.1v15.3h3.2l6.3-10.7v10.7h3.1V19h-3.2l-6.3 10.5Zm-32.5-1.1c-.3 1.7-.8 2.4-1.7 2.4l-1.2-.1v3.5c.4.2.7.3 1.6.3 1.6 0 2.7-.9 3.3-2.4a58.7 58.7 0 0 0 1-9.9h4.1v12.1H79V19h-9.8c0 4.6-.1 7.7-.4 9.4Zm24.9 1.8V24c.1-3.9-2.2-5.5-5.6-5.5-2.9 0-5.4 1.6-5.8 5.2h3c.2-1.4 1.3-2 2.8-2 1.5 0 2.5.6 2.7 2.1L87 25.5c-2.6 1-4.6 2.3-4.6 4.8 0 2.6 1.4 4.3 4.3 4.3 2 0 3.3-1 4.3-2.8.2 1.8 1.4 2.7 3.5 2.7h.9v-3H95c-1 0-1.4-.4-1.4-1.3ZM88 31.4c-1.5 0-2.5-.4-2.5-1.7 0-1.2.9-1.7 2.4-2.4l3-1.2v4.2c-.6.6-1.6 1-3 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 37C19.3 37 25 31.4 25 24.5S19.3 12 12.4 12C5.6 12 0 17.6 0 24.5S5.6 37 12.4 37Z",
    fill: "#FFC800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 33.8C13.6 36.3 9 36.7 6 35.2c3.7 2.3 8.5 2.5 12.6.1 4-2.3 6.2-6.6 6.2-11-.2 3.3-2.9 7-7.1 9.5ZM14 13c.9 1.4-1.2 4.2-4.6 6.2-3.4 2-6.9 2.4-7.7.9l-.1-.3c-.2-.6 0-1.5.7-2.5l.3-.4a12.4 12.4 0 0 1 8.7-4.9c1.2 0 2 .2 2.6.7l.1.2Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 14.5c1.5 2.6-1.5 7.2-6.7 10.2-5.3 3-10.7 3.4-12.2.8-.2-.4-.4-1-.4-1.4a12.4 12.4 0 0 0 1.3 6c.4.7 1.1 1.3 2 1.8 2.9 1.6 7.8 1 12.4-1.7 4.7-2.6 7.6-6.7 7.7-10a4.9 4.9 0 0 0-1.1-3.4 12.4 12.4 0 0 0-4-3.3 3.1 3.1 0 0 1 1 1Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 37C19.3 37 25 31.4 25 24.5S19.3 12 12.4 12C5.6 12 0 17.6 0 24.5S5.6 37 12.4 37Z",
    fill: "url(#logo_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.4331 0 0 12.5031 12.4 24.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })))));
};

export default SvgLogo;